<template>
  <keep-alive :include="cachedViews">
    <router-view :key="key" />
  </keep-alive>
</template>

<script>
    export default {
        name: "index",
      computed: {
        cachedViews() {
          return this.$store.state.tagsView.cachedViews
        },
        key() {
          console.log('this.$route.path',this.$route.path)
          return this.$route.path
        }
      },
    }
</script>

<style scoped>

</style>
